import { connect } from 'react-redux'
import { hasUnseenNotificationSelector } from '@opallabs/beacon'
import { actions, selectors } from '@opallabs/wormhole'
import { Calendar as CalendarComponent } from '.'

const mapStateToProps = (state, ownProps) => ({
  activeFilters: selectors.selectActiveFilters(state),
  // The day each end of the tray's live window is set to. There is no selector
  // for it: the tray's own values sit beside its chosen ids, and only the month
  // view reads them.
  filterValues: state.filters?.filterValues,
  selectedFilters: selectors.selectSelectedFilters(state),
  activeFiltersCount: selectors.selectActiveFiltersCount(state),
  content: selectors.selectContent(state),
  currentBrandId: selectors.selectCurrentBrandId(state),
  currentWeekLabelSets: selectors.selectCurrentWeekLabelSets(state),
  hasUnseenNotification: hasUnseenNotificationSelector(state),
  isExportPopoverOpen: state.csvCreated,
  isFiltersTrayOpen: state.filters && state.filters.isTrayOpen,
  // True while a moment or content overlay is open over the page; the React
  // month asks the endpoint again when it goes away. The moment shroud sets it
  // both ways, and it is the only one that can be relied on to clear it: the
  // content shroud's own `registerShroudVisible(false)` sits after an early
  // return that a `returnTo` — which the month always sends — takes. Closing
  // content reaches this through the moment shroud under it.
  isShroudVisible: Boolean(state.isShroudVisible),
  labelSets: selectors.selectV1LabelSets(state),
  moments: selectors.selectFilteredMoments(state),
  unfilteredMomentCount: Object.keys(
    selectors.selectProxiedMoments(state) || {}
  ).length,
  primaryLabelSetId: selectors.selectPrimaryLabelSetId(state),
  story: selectors.getStory(state, ownProps.storyId),
  totalContentInWeek: selectors.selectContentCount(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  getStory: () => dispatch(actions.getStoryV2(ownProps.storyId)),
  navigateTo: (params) => dispatch(actions.navigateTo(params)),
  onExportPopoverConfirm: () =>
    dispatch(actions.setCSVCreated({ created: false })),
  requestPrivacyGroupAccess: (params) =>
    dispatch(actions.requestPrivacyGroupAccess(params)),
  setSearchTerm: (searchString) =>
    dispatch(actions.setSearchTerm(searchString)),
  setWeekViewStartDay: (date) => dispatch(actions.setWeekViewStartDay(date)),
  updateContent: (params) => dispatch(actions.updateContentV2(params)),
  updateMoment: (params) => dispatch(actions.updateMoment(params)),
})

const Calendar = connect(mapStateToProps, mapDispatchToProps)(CalendarComponent)

export default Calendar
